webpackJsonp([118118881846552],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Schulportrait/school_1",
			"orientation": "portrait"
		}, {
			"src": "Schulportrait/school_2",
			"orientation": "portrait"
		}, {
			"src": "Schulportrait/school_3",
			"orientation": "portrait"
		}, {
			"src": "Schulportrait/school_4",
			"orientation": "portrait"
		}, {
			"src": "Schulportrait/school_5",
			"orientation": "portrait"
		}]
	};
	
	var Schulportrait = function (_React$Component) {
		_inherits(Schulportrait, _React$Component);
	
		function Schulportrait() {
			_classCallCheck(this, Schulportrait);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Schulportrait.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Schulportrait',
				text: 'Diese Fotoserie zeigt eine Auswahl unterschiedlicher Klassensessel. Ich habe mich entschieden diese wie  Sch\xFCler-Portraits zu fotografieren, um den Aspekt des Schulportraits hervorzuheben.',
				images: projectElements.images });
		};
	
		return Schulportrait;
	}(_react2.default.Component);
	
	exports.default = Schulportrait;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-school-js-c02ef5b27ad4ccb40340.js